export const data = [
  {
    generation: 'Boomers',
    2016: 16,
    2019: 20
  },
  {
    generation: 'Gen X',
    2016: 16,
    2019: 20
  },
  {
    generation: 'Millennials',
    2016: 21,
    2019: 30
  },
  {
    generation: 'Gen Z',
    2016: 26,
    2019: 40
  }
];
